import React from 'react'
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import HttpRequest from '../../service/httpService';
import { ComboBox, ComboBoxFilterChangeEvent, DropDownList, MultiColumnComboBox, MultiSelectFilterChangeEvent, MultiColumnComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { SetDatainlocalStorage, getDatainlocalStorage } from 'library/storage/Storage';
import { IDynamicList, IValueMultiObject } from '../../library/types/IDynamicList'
import { SystemMuliColumnDropDown } from '../grid/SystemGrid';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';

interface ISystemDropDown extends  IDynamicList {
    onAfterListUpdated?(listItems: any): void
}

interface ISystemDropDownState {
    valueObject?: IValueMultiObject
}


/* text field which should show in Dropdown  make it as  Id field as 'Id' and text field 'Name' in this*/

export default class SystemMultiColumnDropDown extends SystemBase<IDynamicList, ISystemDropDownState>
{
    constructor(props: any) {
        super(props)

    }
    static defaultProps = {
        ...SystemBase.defaultProps,
        autoDisable: true,
        isMultiColumn: false,
        fetchOnFilter: false,
        textField: "Name",
        dataItemKey: "Value",
        placeholder: "- Please Select -",
        className: "input_feild",
        minFilterLength: 3,
        columns: [],
        smartSearch: false,
        filterable: true,
    } as IDynamicList;

    componentDidMount = () => {
        super.componentDidMount();
        this.fetchData(() => this.setValue(this.props.value))
    }
    componentDidUpdate(prevProps: any) {
        if (prevProps.dataSource != this.props.dataSource) {
            this.fetchData(() => this.setValue(this.props.value))
        }
        else if (prevProps.value != this.props.value)
            this.setValue(this.props.value);
            
    }
    fetchData = (valueSetter: any) => {
        if (this.props.dataSource) {
            HttpRequest
                .get(this.props.dataSource)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.setState({
                            ListItemsMulti: response.data.map((item: any, index: number) => { return { Id: item.Id, Name: item.Name, Description: item.Description }} ),

                            value: this.state.value
                            
                        }, () => { this.setValue(this.props.value) });
                    }
                    else {
                        this.setState({
                            ListItemsMulti: [],
                            value: this.state.value
                        });

                    };
                    valueSetter();
                })
                .catch(error => {
                });
        } else {
            this.setState({ ListItemsMulti: [] }, () => { if (this.props.onAfterListUpdated) this.props.onAfterListUpdated(this.state.ListItemsMulti) });
        }
    }
    setValue = (value: any) => {
        if (this.state.ListItemsMulti && this.state.ListItemsMulti.length > 0 && value != undefined && value != null) {
            this.setState({ valueObject: this.state.ListItemsMulti.find((item:any) => item.Id == value) })
        }
        else {

            this.setState({ valueObject: undefined })
        }
    }
    getValue = (value: any) => {
        if (value && value != undefined) {
            return value.Id;
        }
    }
    onChange = (event: any) => {
        if (this.props.onChange && event.target.value != null) {
            this.props.onChange(event, event.target.name, this.getValue(event.target.value));
        }
    }

    onFilterChange = (event: ComboBoxFilterChangeEvent | MultiSelectFilterChangeEvent) => {
        let filter = { ...event.filter };
        if (this.props.smartSearch) {
            if (this.props.minFilterLength && filter.value.length > this.props.minFilterLength)
                this.fetchData(filter.value)
            else this.setState({ listItems: [], filteredItems: [] });

        } else {
            if (!this.props.minFilterLength || filter.value.length >= this.props.minFilterLength)
                this.setState({ filteredItems: this.filterData(filter) });
            else
                this.setState({ filteredItems: this.state.listItems });
        }
    }
    filterData = (filter: FilterDescriptor) => {
        return filterBy(this.state.listItems, filter);
    };

    render() {
        let isEmpty = !(this.state.filteredItems && this.state.filteredItems.length > 0)
        let isDisabled = this.props.disabled || (!this.props.smartSearch && this.props.autoDisable && isEmpty);
        return (
            <this.WrapperDiv>
                <MultiColumnComboBox 
                    className="col-sm-8  valid custom-kendo-grid "
                    name={this.props.name}
                    id={this.props.id}
                    data={this.state.ListItemsMulti || []}
                    value={this.state.valueObject}
                    columns={this.props.columns}
                    textField={this.props.MultiColumnText}
                    placeholder='- Select -'
                    onChange={this.onChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    filterable={this.props.smartSearch || this.props.filterable}
                    disabled={isDisabled}
                    onFilterChange={this.onFilterChange}

                />
            </this.WrapperDiv>
        );
    }
}
